import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useRecoilState } from 'recoil';
import { OAuthData } from '../../recoil-states/user-state/user-OAuth';
import {
	membership_rank,
	WalletConnectModalOpen,
} from '../../recoil-states/user-state/user-state';
import NotSiba from '../../assets/mypage_profil.png';
import PlatinumBall from '../../assets/platinum_ball.png';
import BlackBall from '../../assets/membership_black.png';
import GoldBall from '../../assets/membership_gold.png';
import SilverBall from '../../assets/membership_silver.png';
import BronzeBall from '../../assets/membership_bronze.png';
import NABall from '../../assets/membership_na.png';
import Share from '../../assets/icons/share_white.svg';
import Link from '../../assets/MypageConnect.png';
import Option from '../../assets/MypageSetting.png';
import MobileOption from '../../assets/mobile_assets/icons/m_option_icon.svg';
import MobileCopy from '../../assets/mobile_assets/icons/m_copy_icon.svg';
import QuestionMark from '../../assets/mypage_modal.png';
import profileImage from '../../assets/default_profile.png';
import { isMobile } from 'react-device-detect';
import { decryptedData, _formatPrice } from '../../function/functions';
import moment from 'moment';
import {
	useAccount,
	useConnect,
	useDisconnect,
	useNetwork,
	useProvider,
	useSignMessage,
} from 'wagmi';

const MyPageHeader = ({
	setCategory,
	textData,
	checkUserStaking,
	userStakingInfo,
	modalOpen,
	setOpenEditModal,
	setMembershipModal,
	myBalance,
	shillaModal,
	diffDay,
	_totalBalance,
	myStakingMount = 0,
	_kctStakingAmount,
	userEth,
	tierAmountMin,
	huobiPrice,
	network,
}) => {
	const [walletConnectmodal, setWalletConnectModal] = useRecoilState(
		WalletConnectModalOpen
	);
	const [userData, setUserData] = useRecoilState(OAuthData);
	// const [userMembership, setUserMembership] = useRecoilState(membership_rank);
	const { connectAsync, connectors } = useConnect();
	const { disconnectAsync } = useDisconnect();
	const { isConnected, isDisconnected, address } = useAccount();
	const { chain, chains } = useNetwork();
	const { signMessageAsync } = useSignMessage();
	const provider = useProvider();
	const chainId = chain ? chain?.id : chains[0]?.id;
	const account = address ?? null;
	const checkTier = () => {
		if (myStakingMount >= tierAmountMin[4] / huobiPrice) return 'platinum';
		else if (myStakingMount >= tierAmountMin[3] / huobiPrice)
			return 'black';
		else if (myStakingMount >= tierAmountMin[2] / huobiPrice) return 'gold';
		else if (myStakingMount >= tierAmountMin[1] / huobiPrice)
			return 'silver';
		else if (myStakingMount >= 100) return 'bronze';
		else if (myStakingMount <= 0) return 'N/A';
		else return 'N/A';
	};
	const userMembership = checkTier();
	/**
	 * mypage 프로필 옆 주소 복사
	 * @param {string} text staking 기간 설정 버튼 클릭 값
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @function _copyToClipBoard
	 * @async
	 */
	const _copyToClipBoard = async text => {
		try {
			await navigator.clipboard.writeText(text);
			alert(textData.mypage2.copyAdress);
		} catch (error) {
			alert('주소 복사에 실패했습니다.');
		}
	};
	const membershipTierMap = {
		platinum: 'Tier1',
		black: 'Tier1',
		gold: 'Tier2',
		silver: 'Tier2',
		bronze: 'Tier2',
		'N/A': '',
		default: '',
	};
	const membershipBalls = {
		platinum: PlatinumBall,
		black: BlackBall,
		gold: GoldBall,
		silver: SilverBall,
		bronze: BronzeBall,
		'N/A': NABall,
		default: NABall,
	};
	/**
	 * 유저 멤버십 등급에따라 이미지 노출 변경
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @function membershipImage
	 * @return {src} <img>
	 */
	const membershipImage = () => {
		const userTier = checkTier();
		return membershipBalls[userTier] || membershipBalls['default'];
	};
	const membershipTier = () => {
		const userTier = checkTier();
		return membershipTierMap[userTier] || membershipTierMap['default'];
	};

	return (
		<div className='myPage_header'>
			<Container className='myPage_profile_contain'>
				<Row className='headerBg'>
					<Col xl='7' lg='12' md='12'>
						<Row className='myPage_profile_wrap'>
							<Col
								xl='4'
								lg='12'
								md='12'
								className='myPage_profile_img_wrap'>
								<div
									style={
										shillaModal.isOpen
											? { zIndex: '-1' }
											: null
									}
									className='profile_img'
									onClick={() => {
										setOpenEditModal(true);
									}}>
									<img
										className='profile'
										src={
											userData?.profile_image_url !==
												null &&
											userData?.profile_image_url
												? userData?.profile_image_url
												: profileImage
										}
									/>
								</div>
							</Col>
							<Col
								xl='8'
								lg='12'
								md='12'
								className='myPage_profile_text_wrap'>
								<button
									onClick={() => {
										setOpenEditModal(true);
									}}>
									<img
										src={
											isMobile ||
											window.innerWidth <= 1200
												? MobileOption
												: Option
										}
									/>
									<span>
										{textData &&
											textData.mypage2.editProfile}
									</span>
								</button>
								<h3>
									{userData?.profile_nick_name ?? 'nickname'}
								</h3>
								<div className='text_wallet'>
									<h4>
										{(account?.slice(0, 4) ?? '') +
											'...' +
											(account?.slice(28, 42) ?? '')}
									</h4>
									{address ? (
										<img
											src={MobileCopy}
											onClick={() => {
												_copyToClipBoard(account);
											}}
											alt='copy_address'
										/>
									) : (
										null ?? null
									)}
								</div>
								<div className='text_wallet'>
									<h4>{userData?.email ?? ''}</h4>
									{userData?.email ? (
										<img
											src={MobileCopy}
											onClick={() => {
												_copyToClipBoard(
													userData?.email
												);
											}}
											alt='copy email'
										/>
									) : (
										null ?? null
									)}
								</div>
								{/* {
                                window.innerWidth <= 1200
                                    ?
                                    <div className="membership_standard">
                                        <p>{textData && textData.mypage2.MEMBERSHIPSTANDARD}</p>
                                        <img src={modalOpen} onClick={() => { setMembershipModal(true) }} />
                                    </div>
                                    : null
                            } */}
							</Col>
						</Row>
					</Col>
					<Col
						xl='5'
						lg='12'
						md='12'
						className='myPage_token_wrap_container'
						style={{ position: 'relative' }}>
						<Row className='myPage_token_wrap'>
							{isMobile || window.innerWidth <= 1200 ? (
								<p className='myPage_token_wrap_HeaderText'>
									My Membership
									<img
										src={QuestionMark}
										alt='?'
										onClick={() => {
											setMembershipModal(true);
										}}
									/>
								</p>
							) : null}
							<div className='myPage_token_wrap_innercontainer'>
								<Col
									xl='5'
									lg='5'
									md='6'
									sm='4'
									xs='4'
									className='myPage_token_img_wrap'>
									{/* <p>tier1</p> */}
									<h3>
										{userMembership &&
										userMembership.length > 0
											? userMembership.toUpperCase()
											: 'N/A'}
									</h3>
									<div className='token_level'>
										<img
											src={membershipImage(
												userMembership
											)}
										/>
									</div>
									<h3>{membershipTier(userMembership)}</h3>
								</Col>
								<Col
									lg='7'
									md='6'
									sm='8'
									xs='8'
									className='myPage_token_text_wrap'>
									<div className='myPage_token_list_wrap'>
										<article>
											<h4>
												{textData &&
													textData.mypage2
														.totalBalance}
											</h4>
											<div>
												<h3
													style={{
														fontFamily: 'NotoSansB',
													}}>
													{myBalance &&
														(_formatPrice(
															+myBalance
														) ??
															'0')}{' '}
													{userStakingInfo[0]?.currency_type?.toUpperCase()}
												</h3>
												<h4>
													${' '}
													{_totalBalance() === ''
														? '0'
														: _totalBalance() ??
														  '0'}
												</h4>
											</div>
										</article>
										{userStakingInfo && (
											<article>
												<h4>
													{textData &&
														textData.mypage2
															.stakingAmount}
												</h4>
												<div>
													<h3
														style={{
															fontFamily:
																'NotoSansB',
														}}>
														{myStakingMount &&
														Number.isInteger(
															myStakingMount
														)
															? myStakingMount
																	?.toString()
																	.replace(
																		/\B(?=(\d{3})+(?!\d))/g,
																		','
																	)
															: Number(
																	myStakingMount
															  )
																	?.toFixed(3)
																	.toString()
																	.replace(
																		/\B(?=(\d{3})+(?!\d))/g,
																		','
																	) ?? 0}{' '}
														{userStakingInfo[0]?.currency_type?.toUpperCase()}
													</h3>
													<h4>
														${_kctStakingAmount()}
													</h4>
												</div>
											</article>
										)}
										<article className='day'>
											<h4>
												{textData &&
													textData.mypage2
														.stakingPeriod}
											</h4>
											<div className='day'>
												<h3>
													{Object.keys(
														checkUserStaking
													).length > 0 &&
													checkUserStaking.processing
														.length > 0
														? moment(
																checkUserStaking
																	.processing[0]
																	.staking_start_date
														  ).format('YY/MM/DD')
														: null}{' '}
													~{' '}
													{Object.keys(
														checkUserStaking
													).length > 0 &&
													checkUserStaking.processing
														.length > 0
														? moment(
																checkUserStaking
																	.processing[0]
																	.staking_end_date
														  ).format('YY/MM/DD')
														: null}
												</h3>
												{diffDay >= 0 && (
													<h4>
														({diffDay} days left)
													</h4>
												)}
											</div>
										</article>
										<article>
											<h4>My ETH</h4>
											<div>
												<h3
													style={{
														fontFamily: 'NotoSansB',
													}}>
													{userEth &&
														(_formatPrice(
															+userEth
														) ??
															'0')}{' '}
													ETH
												</h3>
											</div>
										</article>
									</div>
								</Col>
							</div>
							{/* <div className="myPage_token_button_wrap">
                            <button
                                style={isConnected ? { cursor: "pointer" } : { cursor: "default" }}
                                onClick={() => {
                                    if (isConnected) {
                                        setCategory("staking");
                                    }
                                }}
                            >
                                {textData && textData.mypage2.stake}
                            </button>
                        </div> */}
						</Row>
					</Col>
				</Row>
			</Container>
		</div>
	);
};
export default MyPageHeader;
